// src/multiselect/src/components/translations-context/translations-context.tsx
import { createContext } from "react";
import { jsx } from "react/jsx-runtime";
var TranslationsContext = createContext({
  formatAriaRemoveLabel() {
    if (process.env.NODE_ENV === "development") {
      throw Error("formatAriaRemoveLabel must be called inside context");
    }
    return "";
  }
});
var TranslationsContextPovider = ({
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsx(TranslationsContext.Provider, { value: props, children });
};

export {
  TranslationsContext,
  TranslationsContextPovider
};
